module.exports = __webpack_public_path__ + "assets/img/ec0d7079b54912efc214a49ff386be09.png";